export class StreamingAlertsResponeModel {
    public fromAlertHistory = false;
    public SYMBOL = '';
    public DESCRIPTION = '';
}